import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problemtrip() {
  return (
    <section className="problem_trip p-100 text_trip">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="my-auto text-center"
          >
            <h2>
              Project <span>Log</span>
            </h2>
          </Col>
        </Row>
        <Row className="marg_top">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              The <span>Problem?</span>
            </h2>
            <p>
              The client had a structure that was not able to go live. Full of
              iOS, Android, and web bugs, incomplete payment process, single
              currency support, and no Apple Pay.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="problemm_trip_img">
              <StaticImage
                src="../../../images/case-studies/equi-trip/problem_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={791}
                height={396}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problemtrip;
